import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ExecQtyWithMultiCurrency} from '../../orders-widget/display-order.factory';

@Component({
    selector: 'order-exec-qty-bar',
    templateUrl: './order-exec-qty-bar.component.html',
    styleUrls: ['./order-exec-qty-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderExecQtyBarComponent {

    @Input()
    public execQtyWithMultiCurrency: ExecQtyWithMultiCurrency;

}
